//--------------------------
//HANDLE SAMPLE BLOCKS
//--------------------------

//Fetch -> Call this above
async function fetchAndAddSampleBlocks(newInspirationBlocks, currentPage) {
  //Get already inserted sample blocks
  const alreadyInsertedSampleBlocks = [
    ...document.querySelectorAll(".Inspiration-block--sample"),
  ];
  //Get their links (as a unique ID)
  const usedSampleLinks = getAlreadyShownBlockDataName(
    alreadyInsertedSampleBlocks
  );

  try {
    //Get "en" if english or something else if swedish
    let firstSubUrl = window.location.pathname.split("/")[1];
    if (firstSubUrl != "en") {
      firstSubUrl = "sv";
    }

    const response = await fetch(
      `${window.location.origin}/wp-json/atta45/v1/samples?lang=${firstSubUrl}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    //Get all samples from database
    const samplesData = await response.json();
    //Remove already inserted blocks from data

    const filteredSamplesData = filterAwayAlreadyShownBlocks(
      samplesData,
      usedSampleLinks
    );
    //Add new one as needed
    addSamplesBlocks(filteredSamplesData, newInspirationBlocks, currentPage);
  } catch (error) {
    console.error(error);
  }
}

//Insert
function addSamplesBlocks(
  filteredSamplesData,
  newInspirationBlocks,
  currentPage
) {
  let insertedIndex = 0;

  newInspirationBlocks.forEach((block, i) => {
    if ((i % 10) - 6 == 0 && currentPage % 2 == 0) {
      if (filteredSamplesData.length > insertedIndex) {
        const newSamplesBlock = createSampleBlock(
          filteredSamplesData[insertedIndex]
        );
        block.after(newSamplesBlock);

        insertedIndex++;
      }
    }
  });
}

//Returns a div to be appended
function createSampleBlock(samplesData) {
  const samplesBlockElement = document.createElement("div");
  samplesBlockElement.classList.add("Inspiration-block");
  samplesBlockElement.classList.add("Inspiration-block--sample");
  samplesBlockElement.dataset.name = samplesData["post_name"];

  const aTag = document.createElement("a");
  //Slug has been manualy added with php
  aTag.href = samplesData["slug"];
  samplesBlockElement.appendChild(aTag);

  //Get "en" if english or something else if swedish
  let firstSubUrl = window.location.pathname.split("/")[1];

  const preWord = firstSubUrl == "en" ? "Sample" : "Prov";

  const spanTag = document.createElement("span");
  spanTag.innerHTML = "(" + preWord + ") " + samplesData["post_title"];
  aTag.appendChild(spanTag);

  const fields = samplesData["fields"];
  if (fields["display_image"]) {
    const headerImageUrl = fields["display_image"]["sizes"]["medium"];

    if (headerImageUrl) {
      const figureTag = document.createElement("figure");
      figureTag.classList.add("Inspiration-block--hoverImageWrapper");
      aTag.appendChild(figureTag);
      imgTag = document.createElement("img");
      imgTag.src = headerImageUrl;
      figureTag.appendChild(imgTag);
    }
  }

  return samplesBlockElement;
}

//--------------------------
//HANDLE GUIDE BLOCKS
//--------------------------

//Fetch -> Call this above
async function fetchAndAddGuideBlocks(newInspirationBlocks, currentPage) {
  //Get already inserted guide blocks
  const alreadyInsertedGuideBlocks = [
    ...document.querySelectorAll(".Inspiration-block--guide"),
  ];
  //Get their links (as a unique ID)
  const usedGuideLinks = getAlreadyShownBlockDataName(
    alreadyInsertedGuideBlocks
  );

  try {
    //Get "en" if english or something else if swedish
    let firstSubUrl = window.location.pathname.split("/")[1];
    if (firstSubUrl != "en") {
      firstSubUrl = "sv";
    }

    const response = await fetch(
      `${window.location.origin}/wp-json/atta45/v1/chosen-guides?lang=${firstSubUrl}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    //Get all guides from database
    const guidesData = await response.json();
    //Remove already inserted blocks from data

    const filteredGuidesData = filterAwayAlreadyShownBlocks(
      guidesData,
      usedGuideLinks
    );
    //Add new one as needed
    addGuideBlocks(filteredGuidesData, newInspirationBlocks, currentPage);
  } catch (error) {
    console.error(error);
  }
}

//Insert
function addGuideBlocks(filteredGuidesData, newInspirationBlocks, currentPage) {
  let insertedIndex = 0;

  newInspirationBlocks.forEach((block, i) => {
    if ((i % 10) - 3 == 0) {
      if (filteredGuidesData.length > insertedIndex) {
        const newGuidesBlock = createGuideBlock(
          filteredGuidesData[insertedIndex]
        );
        block.after(newGuidesBlock);

        insertedIndex++;
      }
    }
  });
}

//Returns a div to be appended
function createGuideBlock(guideData) {
  //Get "en" if english or something else if swedish
  let en = window.location.pathname.split("/")[1];
  en === "en" ? "en" : "";

  const guideBlockElement = new ElementCreator("div")
    .addClass("Inspiration-block")
    .addClass("Inspiration-block--guide")
    .addDataset("name", guideData["post_name"])
    .getElement();

  let href = `/guide/#${guideData["post_name"]}`;
  if (en === "en") {
    href = `/en/guide/#${guideData["post_name"]}`;
  }

  const aTag = new ElementCreator("a")
    .setHref(href)
    .appendAsChildTo(guideBlockElement)
    .getElement();

  new ElementCreator("span")
    .setInnerHTML("(Guide) " + guideData["post_title"])
    .appendAsChildTo(aTag);

  if (guideData["imageUrl"] && guideData["imageUrl"] != "") {
    const figureTag = new ElementCreator("figure")
      .addClass("Inspiration-block--hoverImageWrapper")
      .appendAsChildTo(aTag)
      .getElement();

    new ElementCreator("img")
      .setSrc(guideData["imageUrl"])
      .appendAsChildTo(figureTag);
  }
  return guideBlockElement;
}

//HELPERS
function getAlreadyShownBlockDataName(alreadyInsertedBlocks) {
  const usedLinksReturnArray = [];
  alreadyInsertedBlocks.forEach((block) => {
    const dataName = block.dataset.name;
    usedLinksReturnArray.push(dataName);
  });
  return usedLinksReturnArray;
}

//Returns array of non-used block data
function filterAwayAlreadyShownBlocks(data, alreadyUsedNames) {
  const filteredSamples = [];

  for (let i = 0; i < data.length; i++) {
    let found = false;
    for (let j = 0; j < alreadyUsedNames.length; j++) {
      if (data[i]["post_name"] === alreadyUsedNames[j]) {
        found = true;
        break;
      }
    }
    if (!found) {
      filteredSamples.push(data[i]);
    }
  }
  return filteredSamples;
}
